/**
 * Green Flag — CityPillSkeleton
 *
 * Loading placeholder for {@link CityPill}. Matches the pill's footprint
 * (full border radius, the same px/py and font-driven height as the "Atlanta"
 * button) so the Events page top section doesn't jerk when the real pill
 * appears once data resolves. Non-interactive.
 */

import { Skeleton } from "@chakra-ui/react";

export const CityPillSkeleton = () => (
  <Skeleton
    display="inline-block"
    borderRadius="full"
    // Mirror CityPill: px="5" py="2" fontSize="md" → ~5rem wide, ~2.5rem tall.
    w="6rem"
    h="2.5rem"
  />
);
